/**
 * StaleDataNotice — visible indicator that the data on screen is cached, not
 * fresh: either a background refetch is in flight, or one just failed. Never
 * a blocking spinner (the cached data stays fully visible and usable) and
 * never silent (a failed background refresh must not look identical to "this
 * is current" — the exact bug this component exists to close across
 * CensusSummary and the org/ACL admin screens).
 *
 * Mirrors the pattern PatientPicker.tsx established:
 * `{(isFetching || isError) && patients && <p role="status">...}`.
 */
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

export interface StaleDataNoticeProps {
  isFetching: boolean;
  isError: boolean;
  className?: string;
}

export function StaleDataNotice({ isFetching, isError, className }: StaleDataNoticeProps) {
  const { t } = useTranslation();
  if (!isFetching && !isError) return null;
  return (
    <p role="status" className={cn('text-[13px] text-neutral-500', className)}>
      {t('common.staleData')}
    </p>
  );
}
